import common from '@page/common/js/common';
import Pagination from '@global/components/global/Pagination';
import Slick from '@global/vendors/vue-slick.vue';
import Vue from 'vue';
import $ from 'jquery';
import fireShopListViewEvent from '@global/gtm/shopList/shopListView';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';

require('sticky-kit/dist/sticky-kit');

const bannerSlider = new Vue({
  el: '#banner-slider',
  data: {
    bannerSliderConfig: {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 800,
      autoplay: false,
      autoplaySpeed: 6000,
    },
  },
  mounted() {
    if ($('.banner-slide').length) {
      $('.banner-slide').slick(this.bannerSliderConfig);
    }
  },
});

const allProductList = new Vue({
  el: '#all-product-list',
  name: 'AllProductList',
  data: {
    sortConditionData: null,
    sortConditionIsLoad: false,
    searchLocation: window.location.search,
    pathName: window.location.pathname,
    keyStr: 'OM=',
    mode: {
      '/recent': 1,
      '/hot': 5,
      '/favorite': null,
    },
    sortMode: null,
    selectedSizes: [],
    isHovering: false,
    mobileMaskHeight: 1000,
  },
  computed: {
    lowToHigh() {
      return this.locationSearchFilter(4);
    },
    highToLow() {
      return this.locationSearchFilter(3);
    },
    newToOld() {
      return this.locationSearchFilter(1);
    },
    hottest() {
      return this.locationSearchFilter(6);
    },
  },
  watch: {
    sortConditionIsLoad() {
      this.getInitArgs();
    },
  },
  created() {
    const _this = this;
    $.ajax({
      type: 'GET',
      url: API_URL.SORT_POPUP,
      dataType: 'json',
      xhrFields: {
        withCredentials: true,
      },
      success(res) {
        if (res.Code === 200) {
          _this.sortConditionData = res.Response;
          _this.sortConditionIsLoad = true;
        }
      },
    });
    this.sortMode = this.getOrderMode();
  },
  mounted() {
    const _this = this;
    setTimeout(() => {
      if ($('.product-row').height() === 0) {
        _this.mobileMaskHeight = 870;
      } else {
        _this.mobileMaskHeight =
          $('.product-row').height() + 70 < 830 ? 1000 : $('.product-row').height() + 70;
      }
    }, 1200);
  },
  methods: {
    getOrderMode() {
      const ModeStr = this.searchLocation.search('OM');

      if (ModeStr !== -1) {
        return parseInt(this.searchLocation.charAt(ModeStr + 3));
      }

      if (this.mode.hasOwnProperty(this.pathName)) {
        return this.mode[this.pathName];
      }

      return 1;
    },
    locationSearchFilter(orderNum) {
      let argsString = '';

      if (window.location.search.length) {
        let args = window.location.toString().split('?')[1].split('&');

        args = args.filter((ele) => {
          return ele.indexOf('OM') === -1 && ele.indexOf('P=') === -1;
        });

        argsString = args.length ? `${args.join('&')}&` : `${args.join('&')}`;
      }

      return `?${argsString}OM=${orderNum}`;
    },
    goSortPage(sortType) {
      this.sortMode = sortType;
    },
    goSearch() {
      switch (this.sortMode) {
        case 1:
          window.location = this.newToOld;
          break;
        case 4:
          window.location = this.lowToHigh;
          break;
        case 6:
          window.location = this.hottest;
          break;
        default:
          window.location = this.highToLow;
          break;
      }
    },
    reset() {
      if (window.location.search.length) {
        let args = window.location.toString().split('?')[1].split('&');

        args = args.filter((ele) => {
          return ele.indexOf('OM') === -1 && ele.indexOf('P=') === -1;
        });

        if (args.length) {
          window.location = `?${args.join('&')}`;
          return;
        }
      }
      window.location = this.pathName;
    },
    addSize(size) {
      const sizeIndex = this.selectedSizes.findIndex((ele) => ele === size.Value);
      sizeIndex !== -1
        ? this.selectedSizes.splice(sizeIndex, 1)
        : this.selectedSizes.push(size.Value);
    },
    toggleSize(size) {
      return this.selectedSizes.includes(size.Value);
    },
    clearCondition() {
      this.selectedSizes = [];
    },
    goResult() {
      let argsString = '';

      if (window.location.search.length) {
        let args = window.location.toString().split('?')[1].split('&');

        args = args.filter((ele) => {
          return ele.indexOf('S=') === -1 && ele.indexOf('P=') === -1;
        });

        if (args.length) {
          argsString = this.selectedSizes.length ? `${args.join('&')}&` : `${args.join('&')}`;
        }
      }

      // 有選擇 Size
      if (this.selectedSizes.length) {
        window.location.href = `${this.pathName}?${argsString}${this.getSizeArg()}`;
        return;
      }

      // 1.原本就沒有查詢條件
      // 2.原本是 S 或 P 但後來取消顏色篩選
      if (argsString.length === 0) {
        window.location.href = this.pathName;
        return;
      }

      // 沒有選擇 Size 但有選擇 OM
      window.location.href = `${window.location.pathname}?${argsString}`;
    },
    getInitArgs() {
      const initSize = this.getTargetArgValue('S=').split(',');
      if (initSize[0].length !== 0) this.selectedSizes = initSize;
    },
    getTargetArgValue(arg) {
      let targetArg = '';
      if (window.location.search.length !== 0 && window.location.search.indexOf(arg) !== -1) {
        const args = window.location.toString().split('?')[1].split('&');
        args.forEach((element) => {
          if (element.indexOf(arg) !== -1) {
            targetArg = element;
          }
        });
      }
      return targetArg.length !== 0
        ? targetArg.substring(targetArg.indexOf('=') + 1, targetArg.length)
        : '';
    },
    getSizeArg() {
      return this.selectedSizes.length !== 0 ? `S=${this.selectedSizes.toString()}` : '';
    },
    clear() {
      window.location.href = window.location.pathname;
    },
    goMobileResult() {
      let modString = '';
      switch (this.sortMode) {
        case 1:
          modString = this.newToOld;
          break;
        case 6:
          modString = this.hottest;
          break;
        case 4:
          modString = this.lowToHigh;
          break;
        default:
          modString = this.highToLow;
          break;
      }

      let args = modString.split('?')[1].split('&');

      args = args.filter((ele) => {
        return ele.indexOf('S=') === -1 && ele.indexOf('P=') === -1;
      });

      if (this.selectedSizes.length) {
        window.location.href = `${this.pathName}?${args.join('&')}&${this.getSizeArg()}`;
        return;
      }

      window.location.href = `${this.pathName}?${args.join('&')}`;
    },
  },
  template: /* html */ `
  <div>
  <ul class="sort-list">
      <li class="mobile-sort d-sm-none">
          <button @click.prevent="isHovering = !isHovering" class="sort-btn btn">REFINE</button>
          <div v-if="isHovering" :class="{active:isHovering}" :style="{'height' : mobileMaskHeight + 'px'}" class="mobile-sort-menu">
              <p class="sort-title">SORT BY</p>
              <ul class="sort-select-choose">
                  <li @click="goSortPage(1)" :class="{selected: sortMode === 1}">Newest</li>
                  <li @click="goSortPage(6)" :class="{selected: sortMode === 6}">Editor’s Pick</li>
                  <li @click="goSortPage(4)" :class="{selected: sortMode === 4}">Price Low To High</li>
                  <li @click="goSortPage(3)" :class="{selected: sortMode === 3}">Price High To Low</li>
              </ul>
              <div v-if="sortConditionIsLoad" class="sort-size-block">
                  <p class="sort-title">SIZE</p>
                  <ul class="advanced-select-choose">
                      <template v-for="(size, index) in sortConditionData.Sizes">
                          <li @click.prevent="addSize(size)" :class="{'active':toggleSize(size)}" class="item-size"
                              :key="size.Key">
                              {{size.Key}}
                          </li>
                      </template>
                  </ul>
              </div>
              <button @click="clear" class="btn btn-sort-reset">RESET</button>
              <button @click="goMobileResult" class="btn btn-sort-done">DONE</button>
          </div>
      </li>
      <li class="sort d-none d-sm-block">
          <span class="sort-list-btn" href="#">
              SORT BY
              <i class="icon-sort"></i>
          </span>
          <div class="sub-list-sort">
              <ul class="sort-select-choose">
                  <li @click="goSortPage(1)" :class="{selected: sortMode === 1}">Newest</li>
                  <li @click="goSortPage(6)" :class="{selected: sortMode === 6}">Editor’s Pick</li>
                  <li @click="goSortPage(4)" :class="{selected: sortMode === 4}">Price Low To High</li>
                  <li @click="goSortPage(3)" :class="{selected: sortMode === 3}">Price High To Low</li>
              </ul>
              <a @click="goSearch" class="btn btn-sort-done">DONE</a>
              <a @click="reset" class="btn btn-sort-reset">RESET</a>
          </div>
      </li>
      <li class="advanced-sort d-none d-sm-block">
          <span class="sort-list-btn" href="#">
              SIZE
              <i class="icon-advanced-sort"></i>
          </span>
          <div v-if="sortConditionIsLoad" class="advanced-list-sort">
              <ul class="advanced-select-choose">
                  <template v-for="(size, index) in sortConditionData.Sizes">
                      <li @click.prevent="addSize(size)" :class="{'active':toggleSize(size)}" class="item-size"
                          :key="size.Key">
                          {{size.Key}}
                      </li>
                  </template>
              </ul>
              <button @click="goResult" class="btn btn-sort-done">DONE</button>
              <button @click="clearCondition" class="btn btn-sort-reset">RESET</button>
          </div>
      </li>
  </ul>
</div>
  `,
});

const pagination = new Vue({
  el: '#pagination',
  components: {
    Pagination,
  },
  template: '<Pagination  ></Pagination>',
});

const product = new Vue({
  el: '.product-row',
  methods: {
    fireGTM(customMarketID, size) {
      fireShopListClickGTMEvent({ customMarketID, size });
    },
  },
});

if (!window.location.pathname.includes('search')) {
  fireShopListViewEvent();
}
